import { Routes } from "@angular/router";
import { ModulesComponent } from "./modules.component";
import { usersRoutes } from "./users/users.routes";
import { programRoutes } from "./program/programs-routing.module";
import { reportRoutes } from "./reports/reports-routing.module";
import { dashboardRoutes } from "./dashboard/dashboard-routing.module";
import { salesOrderRoutes } from "./orders/orders-routing.module";
import { clientRoutes } from "./clients/clients.routes";
import { managementRoutes } from "./management/management-routing.module";
import { bcLedgerRoutes } from "./bcledger/bcledger-routing.module";
import { multiLedgerRoutes } from "./multi-ledger/multi-ledger-routing.module";
import { vendorRoutes } from "./vendors/vendors-routing.module";
import { proposalRoutes } from "./proposals/quotes-routing.module";
import { productsRoutes } from "./products/products-routing.module";
import { invoicPreviewRoutes } from "./invoice-preview/invoice-preview-routing.module";
import { samplePORoutes } from "./samplePo/samplepo-routing.module";
import { inventoryPurchaseRoutes } from "./inventoryPurchases/inventory-purchase-routing.module";
import { invoiceReviewRoutes } from "./invoice-review/invoice-review-routing.module";
import { freightQuoteRoutes } from "./freight-quote/freight-quote-routing.module";
import { taskManagementRoutes } from "./task-management/task-management-routing.module";
import { projectWorkflowRoutes } from "./project-workflow/project-workflow-routing.module";
import { cdiRoutes } from "./cdi/cdi-routing.module";
import { dashboardPOCRoutes } from "./dashboard-poc/dashboard-poc-routing.module";
import { downloadMobileAppRoutes } from "./download-mobile-app/download-mobile-app-routing.module";
import { profileRoutes } from "./profile/profile-routing.module";
import { specialsRoutes } from "./specials/specials-routing.module";
import { SidebarResolver } from "../core/resolver/sidebar-resolver.resolver";

export const moduleRoutes: Routes = [
  {
    path: "",
    component: ModulesComponent,
    resolve: {
      userRole: SidebarResolver,
    },
    children: [
      { path: "programs", children: programRoutes },
      { path: "dashboard", children: dashboardRoutes },
      { path: "vendors", children: vendorRoutes },
      { path: "users", children: usersRoutes },
      { path: "reports", children: reportRoutes },
      { path: "orders", children: salesOrderRoutes },
      { path: "management", children: managementRoutes },
      { path: "bcledger", children: bcLedgerRoutes },
      { path: "multi-ledger-association", children: multiLedgerRoutes },
      { path: "vendors", children: vendorRoutes },
      { path: "products", children: productsRoutes },
      { path: "samplepo", children: samplePORoutes },
      { path: "inventory-purchase", children: inventoryPurchaseRoutes },
      { path: "users", children: usersRoutes },
      { path: "clients", children: clientRoutes },
      { path: "proposal", children: proposalRoutes },
      { path: "support-allocation", children: dashboardPOCRoutes },
      { path: "invoice-preview", children: invoicPreviewRoutes },
      { path: "invoice-review", children: invoiceReviewRoutes },
      { path: "cdi", children: cdiRoutes },
      { path: "freight-quote", children: freightQuoteRoutes },
      { path: "task-management", children: taskManagementRoutes },
      { path: "project-workflow", children: projectWorkflowRoutes },
      { path: "download-mobile-app", children: downloadMobileAppRoutes },
      { path: "profile", children: profileRoutes },
      { path: "specials", children: specialsRoutes },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
];
